export default __webpack_public_path__ + "static/media/successCoin.8e4f183c.svg";